import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import CircularProgress from '@mui/material/CircularProgress'
import { RestApi } from '../../services/restapi.service'
import { TokenService } from '../../services/token.service'

type RouteState = 'IN_PROGRESS' | 'SUCCESS' | 'FAILURE'

interface Props {
    component: React.ComponentType<any>;
}

export default function PrivateRoute({ component: AComponent }: Props) {
    const [routeState, setRouteState] = useState<RouteState>('IN_PROGRESS');
    const navigate = useNavigate();

    useEffect(() => {
        async function checkAuth() {
            setRouteState('IN_PROGRESS');
            try {
                await Promise.all([RestApi.main()]);
                setRouteState('SUCCESS');
            } catch (error) {
                setRouteState('FAILURE');
            }
        }
        checkAuth();
    }, []);

    useEffect(() => {
        if (routeState === 'FAILURE') {
            TokenService.setToken(null);
            navigate('/login');
        }
    }, [routeState, navigate]);

    if (routeState === 'IN_PROGRESS') {
        return <CircularProgress />;
    }

    if (routeState === 'SUCCESS') {
        return <AComponent />;
    }

    return null;
}
